export default {
    'ERROR-GET-TAGS-ADMIN': {
    // No custom error thrown inside getAllWithStats(), so no specific errors for GET tags
    },
    'ERROR-UPDATE-TAG': {
        'TAG-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Tag introuvable.",
                en: "Tag not found.",
            },
            redirectPath: '/',
        },
        'TAG-ADMIN-ID-MISMATCH': {
            actionType: 'toast',
            message: {
                fr: "Vous n'avez pas la permission de modifier ce tag.",
                en: "You don't have permission to modify this tag.",
            },
        },
        'TAG-NAME-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Un tag avec ce nom existe déjà.",
                en: "A tag with this name already exists.",
            },
        },
    },
    'ERROR-DELETE-TAG': {
        'TAG-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Tag introuvable.",
                en: "Tag not found.",
            },
            redirectPath: '/',
        },
        'TAG-ADMIN-ID-MISMATCH': {
            actionType: 'toast',
            message: {
                fr: "Vous n'avez pas la permission de supprimer ce tag.",
                en: "You don't have permission to delete this tag.",
            },
        },
    },
};
